// import React from "react";
// import "./Nutricos_Banner.css";

// const NutricosBanner = () => {
//   return (
//      <section className="nutricos_banner">
//       <div className="container">
//         <div className="banner_card">
//           <div className="banner_content">
//             <h2 className="head">
//               Every Great Harvest Begins with the Right Seed.
//             </h2>

//             <p className="text">
//               Discover premium-quality seeds that deliver superior germination,
//               healthy crops, and sustainable agricultural growth
//             </p>
//           </div>
//           <div className="banner_wrapper">
//             <img
//               src="/assets/images/home/why-nutricos/img01.png"
//               alt="Nutrition Drink"
//               className="banner_img"
//             />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default NutricosBanner;

import React from "react";
import "./Nutricos_Banner.css";

const NutricosBanner = () => {
  return (
    <section className="nutricos_banner">
      <div className="container">
        <div className="banner_card">
          <div className="banner_wrapper">
            <img
              src="/assets/images/home/nutricos_banner/tomato_img.jpeg"
              alt="Organic Core"
              className="banner_img"
            />
          </div>

          <div className="banner_content">
            <span className="banner_tag">@SEESDSO</span>

            <h2 className="head">
              Every Great Harvest Begins with the Right Seed
            </h2>

            <p className="text">
              Discover premium-quality seeds engineered for superior
              germination, healthier crops, and sustainable agricultural
              success. Empower your farming journey with trusted quality.
            </p>

           
          </div>
        </div>
      </div>
    </section>
  );
};

export default NutricosBanner;
